import { createSlice } from "@reduxjs/toolkit";
import { ApiStatus } from "../../types/api/status";
import { RootState } from "../store";
import { PreStudent, preStudentsType } from "../../types/slices/preStudentsType";

const initialState: preStudentsType = {
  statusPreStudents: ApiStatus.FETCHED,
  errorMessage: undefined,
  preStudents: [],
  editPreStudent: {} as PreStudent,
  selectedPreStudent: {} as PreStudent,
  isEdit: false,
  openModal: false,
};

const preStudentSlice = createSlice({
  name: "preStudent",
  initialState,
  reducers: {
    onFetchPreStudents(state, { payload }: { payload: PreStudent[] }) {
      state.statusPreStudents = ApiStatus.FETCHED;
      state.preStudents = payload;
      state.errorMessage = undefined;
    },
    changeStatusPreStudents(state, { payload }: { payload: ApiStatus }) {
      state.statusPreStudents = payload;
    },
    onSetEditPreStudent(state, { payload }: { payload: PreStudent }) {
      state.editPreStudent = payload;
    },
    onSetSelectedPreStudent(state, { payload }: { payload: PreStudent }) {
      state.selectedPreStudent = payload;
    },
    onSetOpenModal(state, { payload }: { payload: boolean }) {
      state.openModal = payload;
    },
    onChangeIsEdit(state, { payload }: { payload: boolean }) {
      state.isEdit = payload;
    },
  },
});

export const selectPreStudentState = (state: RootState) => state.preStudentSlice;
export default preStudentSlice.reducer;

export const {
  onFetchPreStudents,
  changeStatusPreStudents,
  onSetEditPreStudent,
  onSetSelectedPreStudent,
  onSetOpenModal,
  onChangeIsEdit,
} = preStudentSlice.actions;